/**
 * 🏷️ IDENTITÉ ET COORDONNÉES DE LA PLATEFORME (source unique)
 * ============================================================
 * Toutes les pages lisent ce fichier : pour changer un numéro, une adresse ou un email,
 * il suffit de le modifier ici (ou dans les variables d'environnement REACT_APP_*).
 */

import { MIN_INVESTMENT_LABEL } from './paymentMethods';

const env = (name, fallback) => (process.env[name] || fallback).trim();

const phone = env('REACT_APP_CONTACT_PHONE', '+227 99 60 26 00');
const whatsapp = env('REACT_APP_CONTACT_WHATSAPP', phone);
const digitsOnly = (value) => value.replace(/[^\d]/g, '');

export const SITE = {
  // Nom affiché partout (logo, titres des onglets, textes)
  name: 'Community ImpactInvest',
  // Nom court, pour les phrases (« l'équipe ImpactInvest »)
  shortName: 'ImpactInvest',
  // Raison sociale (mentions légales, pied de page)
  legalName: 'Community Impact-Invest (C.I.I)',
  legalForm: 'Société unipersonnelle à responsabilité limitée (SARLU)',
  rccm: 'NE-ZIN-2025-B-0465',
  rccmDate: '26/09/2025',
  nif: '150623/R',
  tagline: "Votre capital au service de l'impact social",
  description: `Plateforme d'investissement participatif à impact social au Niger : financez des entrepreneurs locaux dès ${MIN_INVESTMENT_LABEL}.`,

  city: env('REACT_APP_CONTACT_CITY', 'Zinder'),
  country: 'Niger',
  address: env('REACT_APP_CONTACT_ADDRESS', 'Zinder, Niger'),
  postalAddress: env('REACT_APP_POSTAL_ADDRESS', 'Rue CCFN, Zinder, République du Niger'),
  website: env('REACT_APP_SITE_URL', 'https://www.impactinvest-sahel.org'),

  // Directeur de la publication (mentions légales)
  publicationDirector: 'Garba Amadou Issaka',
  publicationDirectorRole: 'Président-fondateur',

  // Hébergeur du site (à mettre à jour si l'hébergement change)
  host: {
    // Site servi par le serveur de la plateforme (Niger) et diffusé par le réseau Cloudflare
    name: env('REACT_APP_HOST_NAME', 'Community ImpactInvest (serveur propre), diffusé par Cloudflare, Inc.'),
    address: env('REACT_APP_HOST_ADDRESS', 'Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, États-Unis'),
    website: env('REACT_APP_HOST_URL', 'https://www.cloudflare.com')
  },

  phone,
  phoneHref: `tel:+${digitsOnly(phone)}`,
  whatsappHref: `https://wa.me/${digitsOnly(whatsapp)}`,

  // Une adresse générale et une adresse dédiée au support (réponses sous 2 jours ouvrés)
  email: env('REACT_APP_CONTACT_EMAIL', 'contact@impactinvest-sahel.org'),
  supportEmail: env('REACT_APP_SUPPORT_EMAIL', 'support@impactinvest-sahel.org'),
  privacyEmail: env('REACT_APP_PRIVACY_EMAIL', 'contact@impactinvest-sahel.org'),

  hours: 'Du lundi au vendredi, de 8 h à 17 h',
  responseTime: '2 jours ouvrés',

  // Réseaux sociaux : laisser vide tant qu'une page officielle n'existe pas (le lien n'est alors pas affiché)
  social: {
    facebook: env('REACT_APP_SOCIAL_FACEBOOK', 'https://www.facebook.com/profile.php?id=61557835354467'),
    linkedin: env('REACT_APP_SOCIAL_LINKEDIN', 'https://www.linkedin.com/company/community-impactinvest/'),
    twitter: env('REACT_APP_SOCIAL_TWITTER', ''),
    youtube: env('REACT_APP_SOCIAL_YOUTUBE', 'https://www.youtube.com/channel/UCC5bY1hYOmtN0qVZdqVRAww')
  }
};

/** Lien WhatsApp avec un message prérempli */
export const whatsappLink = (message) =>
  message ? `${SITE.whatsappHref}?text=${encodeURIComponent(message)}` : SITE.whatsappHref;

/** Lien email avec objet prérempli */
export const mailtoLink = (subject, email = SITE.email) =>
  subject ? `mailto:${email}?subject=${encodeURIComponent(subject)}` : `mailto:${email}`;

export default SITE;
